import { MDSDropdown } from '@marqvision/mds-v2';
import { useSellerOptions } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const SellerFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const sellers = useSellerOptions();

  return (
    <MDSDropdown
      label="Sellers"
      isLoading={sellers.isLoading}
      modules={[
        'hide-select-all',
        {
          type: 'search',
          debounce: 300,
          onChange: sellers.onSearch,
        },
        {
          type: 'infinite',
          total: sellers.list.length,
          hasNextPage: sellers.hasNextPage,

          onScrollBottom: () => {
            if (!sellers.isFetchingNextPage) {
              sellers.fetchNextPage();
            }
          },
        },
        {
          type: 'filter-button',
          size,
        },
      ]}
      list={sellers.list}
      value={sellers.selected}
      onChange={(value) => sellers.select(value)}
    />
  );
};
